import Safe from '../svgs/about/safe.svg';
import Responsive from '../svgs/about/responsive.svg';
import Base from '../svgs/about/base.svg';
import Tools from '../svgs/about/web-tools.svg';
import Support from '../svgs/about/support.svg';
import Lifetime from '../svgs/about/lifetime.svg';

import Compute from '../public/about/compute.svg';
import Storage from '../public/about/storage.svg';
import Networking from '../public/about/networking.svg';
import Artifactory from '../public/about/artifactory.svg';
import Databases from '../public/about/database.svg';
import Outrun from '../public/about/outrun.svg';

export const aboutUsFeatures = [
  {
    feature: 'aboutUsFeatures.featuresOne'
  },
  {
    feature: 'aboutUsFeatures.featuresTwo'
  }
];

export const aboutUsTools = [
  {
    tool: 'aboutUsTools.toolOne'
  },
  {
    tool: 'aboutUsTools.toolTwo'
  },
  {
    tool: 'aboutUsTools.toolThree'
  },
  {
    tool: 'aboutUsTools.toolFour'
  },
  {
    tool: 'aboutUsTools.toolFive'
  }
];

export const get_lists = [
  {
    img: Safe,
    title: 'what_we_get.reliability'
  },
  {
    img: Responsive,
    title: 'what_we_get.design'
  },
  {
    img: Base,
    title: 'what_we_get.knowledge_base'
  },
  {
    img: Tools,
    title: 'what_we_get.web_tools'
  },
  {
    img: Support,
    title: 'what_we_get.support'
  },
  {
    img: Lifetime,
    title: 'what_we_get.lifetime'
  } 
];

export const services = [
  {
    name: 'ICDC Compute',
    link: '/compute',
    img: Compute
  },
  {
    name: 'ICDC Storage',
    link: '/storage',
    img: Storage
  },
  {
    name: 'ICDC Networking',
    link: '/networking',
    img: Networking
  },
  {
    name: 'ICDC Outrun Cloud',
    link: '/outrun-cloud',
    img: Outrun
  },
  {
    name: 'ICDC Database',
    link: '/database',
    img: Databases
  },
  {
    name: 'ICDC Artifactory',
    link: '/artifactory',
    img: Artifactory
  }
];
